import styled from 'styled-components'

export const Header = styled.header`
    grid-column: span 12;
    padding: 0px 40px;
    box-shadow: 4px 0px 12px 2px #cccccc4f;
`

export const Main = styled.main`
    grid-column: span 12;
    overflow: auto;
`

export const Footer = styled.footer`
    grid-column: span 12;
    padding: 40px 120px;
    background-color: #0A0C8A;
    color: #ffffff;
`